export class TransitConfiguration {
    public changeUrl: string;

    constructor(private container: JQuery) {
        const baseUrl = container.attr('data-api-root-prefix');
        this.changeUrl = baseUrl + container.attr('data-change-api-url');
    }
}
